import React from "react";
import Icons from "../common/icons/icons";
import { ENDPOINTS } from "../../js/api/_config";

function ExcelCsvExport({
  trialId,
  token,
  statusID, // optional
  classes,
  containerClass,
  name = "Export",
  type = "EXCEL", // "excel" | "csv"
}) {
  const handleDownload = async () => {
    try {
      let url = `${ENDPOINTS.TRIALS.GET_EXPORT_PATIENT_TRIAL_STATUS}?trialID=${trialId}`;

      if (statusID) {
        url += `&statusID=${statusID}`;
      }

      // let backend know which format is needed
      url += `&exportFileType=${type}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "text/plain",
        },
      });  

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download =
        type === "CSV"
          ? "Trials_Status.csv"
          : "Trials_Status.xlsx";

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  return (
    <div className={`py-5 flex justify-center lg:block ${containerClass}`}>
      <button
        onClick={handleDownload}
        className={`py-2.5 px-5 me-2 text-sm font-medium text-gray-900 bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:outline-none focus:ring-4 focus:ring-gray-100 ${classes}`}
      >
        <div className="flex items-center">
          <Icons status={type === "CSV" ? "csv" : "excel"} />
          <div className="ml-3">{name}</div>
        </div>
      </button>
    </div>
  );
}

export default ExcelCsvExport;
